const LOAN_LIMITS = {
  FROM: 5000,
  UP_TO: 800000,
  UP_TO_HARD_LIMIT: 1000000,
  STEP: 5000,
  NEW_LOAN_LIMIT: 600000,
};

export default LOAN_LIMITS;
